import axios from '../utils/axios/index.js';


export const verifyPasswordApi = (params) => {
  return axios.post('api/securitycenter/verifypassword', params)
}

export const bindEmailApi = (params) => {
  return axios.post('api/securitycenter/bindemail', params)
}

export const changePasswordApi = (params) => {
  return axios.post('api/securitycenter/changepassword', params)
}

export const changeWithdrawalPasswordApi = (params) => {
  return axios.post('api/member/drawing_pwd/modify', params)
}


// WEBPACK FOOTER //
// ./src/api/security.js